module.exports = __webpack_public_path__ + "prod/1.42.2/img/cycle-three.0fd57a35.png";